import React, { useState } from "react";
import Form from "./Form";
import { FormattedMessage } from "react-intl";
import { APP_VERSION, LANGUAGE_OPTIONS } from "../../constants";
import AuthLayout from "../../layouts/AuthLayout";
import LanguageSelect from "../../components/Filter/LanguageSelect";
import { useDispatch, useSelector } from "react-redux";
import { set_language } from "../../redux/slices/languageSlice";
import { setAppLanguage } from "../../utils";

const Login = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const lang = useSelector(state => state.language);
  const selectedLang = lang ? LANGUAGE_OPTIONS.find(item => item.value.code === lang) : null;

  const handleLanguageChange = (value) => {
    dispatch(set_language(value.value.code))
    setAppLanguage(value.value.code)
  };


  const toggleMenu = () => {
    setOpen(!open);
  };
  return (
    <div className='w-full h-full flex pr-5 py-5 justify-center items-center bg-gradient-to-tr bg-base-bg overflow-y-auto'>

      <div className="w-full lg:w-1/2 relative ">
        {/* <div className='absolute -top-9 right-3 w-[125px]'>
          <LanguageSelect
            options={LANGUAGE_OPTIONS}
            state={selectedLang}
            setState={handleLanguageChange}
            disableClearable={true}
            disableSearch={true}
          />
        </div> */}
        <img src="/images/influencee.png" className='mx-auto w-[150px] pb-5  ' />
        <div className=" w-[90%] md:w-[60%] mx-auto px-4 pt-16 pb-10 bg-content-bg rounded-[20px]">
          <h1 className='text-3xl font-bold text-center text-t-light'>
            <FormattedMessage id="login" defaultMessage={"Login"} />
          </h1>
          {
            <p className='text-center text-sm text-t-light w-[90%] mx-auto'>
              <FormattedMessage id="login_desc" defaultMessage={"Welcome back and login below."} />
            </p>
          }
          <Form />
        </div>
      </div>
      <div className="hidden  bg-primary  py-5 px-5 lg:flex flex-col space-y-8  w-1/2 h-full rounded-xl">
        <h1 className="text-5xl mt-16 text-center text-white font-bold">
          <FormattedMessage id="welcome_back" defaultMessage={"Welcome Back!"} /> <br />
          <FormattedMessage id="sign_in_influencee_account" defaultMessage={"Please Sign in to your influencee account"} />
        </h1>
        <hr className="h-[4px] w-1/2 mx-auto" />
        {/* <div className="text-white font-light text-center">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry.

          <p>Lorem Ipsum is simply dummy text of the printing.</p>
        </div> */}

        <div className="">
          <img src="/images/login_page_image.png" className="w-[50%] !-mb-32 rounded-lg mx-auto" />
        </div>
      </div>
    </div>
  );
};

export default Login;
